module.exports = __webpack_public_path__ + "static/media/kelmi.e9e09ef6.png";